(() => {
  const template = document.getElementById('hug-free-shipping-template');
  if (!template) return;
  const drawerSelector = '.Vtl-CartDrawer[aria-hidden="false"]';
  const threshold = Number(template.dataset.limit);
  if (!(threshold > 0)) return;
  let timer;
  let revision = 0;
  let controller;
  let cartSignature;
  let pendingNativeRefresh = false;
  let latestItemCount = 0;
  const update = async () => {
    const drawer = document.querySelector(drawerSelector);
    const anchor = drawer?.querySelector('.Vtl-CartDrawerCheckout__CheckoutButtonContainer');
    if (!drawer) {
      if (pendingNativeRefresh && document.querySelector('#main_content cart-element')) {
        pendingNativeRefresh = false;
        document.querySelector('.layout--viewport')?.setAttribute('data-cart-empty', String(latestItemCount === 0));
        window.dispatchEvent(new Event('theme:cart:refresh'));
      }
      return;
    }
    const current = ++revision;
    controller?.abort();
    controller = new AbortController();
    try {
      const root = template.dataset.root.replace(/\/$/, '');
      const response = await fetch(root + '/cart.js', {signal: controller.signal, headers: {Accept: 'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      if (current !== revision || !drawer.isConnected || drawer.getAttribute('aria-hidden') === 'true') return;
      const signature = JSON.stringify([cart.total_price, cart.items.map(item => [item.key, item.quantity, item.final_line_price])]);
      if (signature !== cartSignature && document.querySelector('#main_content cart-element')) {
        cartSignature = signature;
        latestItemCount = cart.item_count;
        pendingNativeRefresh = true;
      }
      let bar = drawer.querySelector('.hug-free-shipping');
      if (cart.currency !== 'DKK' || !cart.requires_shipping || cart.item_count === 0) {
        if (bar) bar.hidden = true;
        return;
      }
      if (!anchor) return;
      if (!bar) {
        bar = template.content.firstElementChild.cloneNode(true);
        anchor.before(bar);
      }
      const giftCards = cart.items.filter(item => item.gift_card).reduce((sum, item) => sum + item.final_line_price, 0);
      const eligible = Math.max(0, cart.total_price - giftCards);
      const remaining = Math.max(0, threshold - eligible);
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'da-DK', {
        style: 'currency', currency: 'DKK', maximumFractionDigits: 2
      }).format(remaining / 100);
      const message = remaining === 0 ? template.dataset.reached : template.dataset.remaining.replace('__amount__', amount);
      const text = bar.querySelector('.hug-free-shipping__message');
      if (text.textContent !== message) text.textContent = message;
      bar.querySelector('.hug-free-shipping__track > span').style.width = Math.min(100, eligible / threshold * 100) + '%';
      const format = value => new Intl.NumberFormat(document.documentElement.lang || 'da-DK', {
        style: 'currency', currency: 'DKK', maximumFractionDigits: 2
      }).format(value / 100);
      const delivery = remaining === 0 ? 0 : 5900;
      for (const [selector, value] of [['[data-hug-goods]', cart.total_price], ['[data-hug-delivery-paid]', delivery], ['[data-hug-delivery-before]', 5900], ['[data-hug-free-delivery-price]', 0], ['[data-hug-delivered-total]', cart.total_price + delivery]]) {
        const element = bar.querySelector(selector);
        const formatted = format(value);
        if (element.textContent !== formatted) element.textContent = formatted;
      }
      bar.querySelector('[data-hug-delivery-before]').hidden = remaining !== 0;
      bar.querySelector('[data-hug-delivery-paid]').hidden = remaining === 0;
      bar.querySelector('[data-hug-free-delivery]').hidden = remaining !== 0;
      const checkoutText = anchor.querySelector('.Vtl-Button__Text');
      if (checkoutText && checkoutText.textContent !== template.dataset.checkout) checkoutText.textContent = template.dataset.checkout;
      bar.hidden = false;
    } catch (error) {
      if (error.name !== 'AbortError') {
        const bar = drawer.querySelector('.hug-free-shipping');
        if (bar) bar.hidden = true;
      }
    }
  };
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(update, 180);
  };
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target?.closest('.hug-free-shipping, .Vtl-CartDrawerCheckout__CheckoutButtonContainer')) return false;
      if (target?.closest('.Vtl-CartDrawer')) return true;
      return Array.from([...record.addedNodes, ...record.removedNodes]).some(node => node.nodeType === 1 && (node.matches?.('.Vtl-CartDrawer') || node.querySelector?.('.Vtl-CartDrawer')));
    });
    if (relevant) schedule();
  });
  observer.observe(document.body, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-hidden', 'aria-busy']});
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  window.addEventListener('pageshow', schedule);
  schedule();
})();